






































    import _ from 'lodash';
    import {Component, Vue, Watch} from 'vue-property-decorator';
    import {DxButton, DxScrollView, DxTextBox} from 'devextreme-vue';
    import TableGrid from '@/components/TableGrid/grid.vue';
    import DButton from '@/components/DButton/button.vue';
    import {AxiosResponse} from "axios";
    import Cut from "@/components/Cut/index.vue";
    import UserAccess from '@/views/settings/components/user_access.vue'
    import User from "@/views/admin/users/index.vue";
    import ServiceMonitoring from "@/views/admin/monitoring/services.vue";
    import HardwareMonitoring from "@/views/admin/monitoring/hardware.vue";
    import Backup from "@/views/admin/backup/index.vue";
    import ElementTabs from '@/components/ElTabs/tabs.vue';
    import AuthService from "@/services/auth_service";
    import Imbalance_colors from "@/views/admin/imbalance_color/imbalance_colors.vue";
import { confirm } from 'devextreme/ui/dialog';

    @Component({
        name: 'Home',
        components: {
          Imbalance_colors,
          DxButton,
          DxTextBox,
          TableGrid,
          DxScrollView,
          DButton,
          Cut,
          UserAccess,
          ElementTabs,
          User,
          ServiceMonitoring,
          HardwareMonitoring,
          Backup,
        }
    })


    export default class extends Vue {
      public auth_service = AuthService;
      private storageKey = 'setting_selected_tab'
      public currentTab = 'cuts';
      public tabsList = [
        {text: "Срезки", key: 'cuts'},
        {text: "Пользователи", key: 'users'},
        {text: "Настройка доступа", key: 'user_access'},
        {text: "Мониторинг модулей", key: 'service_monitoring'},
        {text: "Аппаратная работоспособность", key: 'hardware_monitoring'},
        {text: "Небалансы", key: 'imbalance_color'},
        {text: "Бэкап БД", key: 'backup'},
      ];

        async created() {
          const lastTab = localStorage.getItem(`${this.auth_service.getUserId()}_${this.storageKey}`);
          if (lastTab) {
            this.currentTab = lastTab;
          }
          else {
            this.currentTab = 'cuts';
          }
        }

        async mounted() {

        }

        get gridHeight() {
            return '100%';
        }

        @Watch('currentTab')
        changeTab(e: any) {
          localStorage.setItem(`${this.auth_service.getUserId()}_${this.storageKey}`, this.currentTab);
        }

        destroyed() {

        }

        empty() {
            //
        }

        async beforeRouteLeave(to: any, from: any, next: any) {
          const imbalanceComponent = this.$refs.imbalanceColors as any;

          if (imbalanceComponent && imbalanceComponent.settingsChanged) {
            const answer = await confirm(
              "У вас есть несохранённые изменения. Сохранить перед уходом?",
              "Несохранённые данные"
            );
            if (answer) {
              const saved = await imbalanceComponent.saveColors();
              if (saved.status) {
                next(); 
              } else {
                next(false);
              }
            } else {
              imbalanceComponent.revertColors();
              next();
            }
          } else {
            next();
          }
        }

    }
